// The greeting's date line ("Montag, 21. September · KW 39", workspace-start M2)
// replaces the static subtitle. No new dependency: ISO 8601 week numbering
// (Monday-start weeks, week 1 holds the year's first Thursday) is ~6 lines.

/** ISO 8601 week number for a local date (weeks start Monday). */
export function isoWeekNumber(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7; // Mon=0 … Sun=6
  d.setUTCDate(d.getUTCDate() - dayNum + 3); // nearest Thursday decides the ISO year
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const firstDayNum = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNum + 3);
  return 1 + Math.round((d.getTime() - firstThursday.getTime()) / (7 * 24 * 3600 * 1000));
}

/**
 * "Montag, 21. September · KW 39" — weekday + day/month via `Intl`, then the ISO
 * week through the caller's own translation (`homebase.dateLine.week`), so this
 * util stays translation-agnostic and unit-testable without the i18n plugin.
 */
export function formatDateLine(now: Date, locale: string, weekLabel: (week: number) => string): string {
  const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' }).format(now);
  return `${weekday} · ${weekLabel(isoWeekNumber(now))}`;
}
